import { isEmpty } from 'lodash';

export const texts = {
  'admin.lt4_reviews': '[receiver] has received a review with less than four stars on a lesson with [sender] for [course] at [university].',
  'admin.payment_decline': 'There is a new payment error associated to [user].\nLesson: [other]/[course]/[university]\nTransaction Type: [type]\nMessage: [message]',
  'admin.user_signup': '[student] has just signed up to become a student at [university]!',
  'admin.lesson_completed': 'A lesson between [tutor] and [student] for [course] at [university] has been completed!',
  'admin.lesson_cancelation': '[cancelor] cancelled the lesson with [cancelee] for [course] at [university]',
  'admin.lesson_decline': '[tutor] declined the lesson with [student] for [course] at [university]',
  'admin.lesson_overpending': 'A lesson between [tutor] and [student] for [course] at [university] has been pending for three days.',
  'admin.review_given': '[user] has received a new review from [sender] for a [course] lesson at [university]',
  'admin.course_request': '[user] requested to add [course] for [university]',
  'admin.course_approval_request': '[tutor] requested to teach [course] at [university]',
  'admin.private_location_request': '[user] requested to teach at a private location ([university])',
};

export const handleNavigation = ({ history, key, payload }) => {
  switch (key) {
    case 'admin.lt4_reviews':
    case 'admin.review_given':
      if (isEmpty(payload) || (!payload._student && !payload._tutor) || !payload._review)
        return;
      history.push(payload._student != null ? '/home/students' : '/home/tutors', { tasks: [
        { action: 'fetch', payload: payload._student || payload._tutor },
        { action: 'tab', payload: payload._student != null ? 'feedback' : 'reviews' },
        { action: 'expand_review', payload: payload._review },
      ] });
      return;
    case 'admin.payment_decline':
      if (isEmpty(payload) || (!payload._student && !payload._tutor))
        return;
      history.push(payload._student != null ? '/home/students' : '/home/tutors', { tasks: [
        { action: 'fetch', payload: payload._student || payload._tutor },
        { action: 'tab', payload: 'payment' },
      ] });
      return;
    case 'admin.user_signup':
      if (isEmpty(payload) || !payload._student)
        return;
      history.push(
        '/home/students',
        { tasks: [{ action: 'fetch', payload: payload._student }] }
      );
      return;
    case 'admin.lesson_completed':
    case 'admin.lesson_cancelation':
    case 'admin.lesson_decline':
    case 'admin.lesson_overpending':
      if (isEmpty(payload) || !payload._lesson)
        return;
      // go to lesson
      history.push('/home/lessons', { tasks: [
        { action: 'fetch', payload: payload._lesson },
      ] });
      return;
    default:
      return;
  }
};



// WEBPACK FOOTER //
// ./src/config/constants/notification.js